import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/option'

import component from 'components/Options/New'

const formName = 'new-option'
const fields = ['name']

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  onSubmit: (data) => {
    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, {}, fields))
  }
})

const mapStateToProps = (state) => ({
  option: state.option
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Options/containers/NewOptionContainer.js